import { PayoutStatus } from "@gen/app-query";
import * as z from "zod";

export const adminPayoutsReqSchema = z.object({
  page: z.coerce.number().min(1).default(1),
  pageSize: z.coerce.number().min(1).max(100).default(25),
  client_id: z.string().optional(),
  client_name: z.string().optional(),
  status: z.enum(PayoutStatus).optional(),
  created_from: z.string().optional(),
  created_to: z.string().optional(),
  currency: z.string().optional(),
  is_instant: z.boolean().optional(),
  payout_id: z.string().optional(),
  stripe_payout_id: z.string().optional(),
});
